import { render, staticRenderFns } from "./expoCategoryList.vue?vue&type=template&id=60073c7f&scoped=true"
import script from "./expoCategoryList.vue?vue&type=script&lang=js"
export * from "./expoCategoryList.vue?vue&type=script&lang=js"
import style0 from "./expoCategoryList.vue?vue&type=style&index=0&id=60073c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60073c7f",
  null
  
)

export default component.exports